/* eslint-disable */

import ActionCarousel from './actionCarousel/ActionCarousel'
import { useEffect, useState } from 'react'
import { InvestedPlansSelector } from '../../store/InvestedPlansStore'
import {
  useRecoilRefresher_UNSTABLE,
  useSetRecoilState,
  useRecoilValueLoadable,
} from 'recoil'
import { toCurrency } from '../../utils/CurrencyUtil'
import { useLocation, useNavigate } from 'react-router-dom'
import { messageModalState } from '../../store/Feedback'
import { deleteReq, get } from '../../http/restservice'
import { Bell, EllipsisVertical } from 'lucide-react'
import { Separator } from '../../Components/ui/separator'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../../Components/ui/alert-dialog'
import {
  Menubar,
  MenubarContent,
  MenubarItem,
  MenubarMenu,
  MenubarTrigger,
} from '../../Components/ui/menubar'
import ActionNotification from './ActionNotification'
import env from '../../env/env'
import { capitalizeWords } from '../../utils/Util'
import { MFUserSubSeqBaskets } from '../../store/AdminStore'
import { useModal } from '../../hooks/use-modal-store'
import basketRowIcon from '../../assets/SVGS/fabits-basket-row-icon.svg'
import { Card, CardContent } from '../../Components/ui/card'
import { Button } from '../../Components/ui/button'
import { Skeleton } from '../../Components/ui/skeleton'
import { cn } from '../../lib/utils'

const getStatus = (status) => status?.toUpperCase()

const getGoalAmount = (item) => {
  const table1 = item?.results?.table || {}
  let totalExpenses = 0
  let totalPlannedContribution = 0

  Object.values(table1).forEach((value) => {
    totalExpenses += value?.projectedExpenses || 0
    totalPlannedContribution += value?.plannedContribution || 0
  })

  if (item.planType === 'RETIREMENT') {
    totalExpenses = table1['1']?.corpus || 0
  }

  let totalInvestementPlanned
  if (item.planType === 'HOLIDAY' || item.planType === 'CHILDEDUCATION') {
    totalInvestementPlanned = totalExpenses - totalPlannedContribution
  } else {
    totalInvestementPlanned = totalExpenses - (table1['1']?.fvOfCurrentValue || 0)
  }

  return totalInvestementPlanned > 0 ? totalInvestementPlanned : 0
}

const getStatusClassName = (status) => {
  const normalized = getStatus(status)
  if (normalized === 'INVESTED' || normalized === 'PARTIALLY_INVESTED') {
    return 'text-[var(--fb-positive)]'
  }
  return 'text-[var(--fb-warning)]'
}

const PlanMetric = ({ label, value, valueClassName }) => (
  <div className='min-w-0'>
    <p className='fabits-eyebrow'>{label}</p>
    <p
      className={cn(
        'mt-1.5 font-DMSans text-sm font-bold tracking-tight text-[var(--fb-text-strong)] md:text-base',
        valueClassName,
      )}
    >
      {value}
    </p>
  </div>
)

const PlanCardShell = ({ children }) => (
  <article className='flex h-full flex-col overflow-hidden rounded-2xl border border-[var(--fb-border)] bg-[var(--fb-surface)] p-4 shadow-[var(--fb-shadow-sm)] transition-shadow hover:shadow-[var(--fb-shadow-md)] md:p-5'>
    {children}
  </article>
)

const PlanCardSkeletons = () => (
  <>
    {Array.from({ length: 3 }).map((_, index) => (
      <Skeleton key={index} className='h-52 rounded-2xl bg-[var(--fb-surface-muted)]' />
    ))}
  </>
)

const EmptyPlansState = ({ title, description }) => (
  <div className='col-span-full rounded-2xl border border-dashed border-[var(--fb-border)] bg-[var(--fb-surface-muted)] px-5 py-10 text-center'>
    <p className='font-DMSans text-base font-semibold text-[var(--fb-text-strong)]'>{title}</p>
    <p className='mt-1 text-sm text-[var(--fb-text-muted)]'>{description}</p>
  </div>
)

const AddPlan = () => {
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false)
  const [plans, setPlans] = useState()
  const [mergedPlans, setMergedPlans] = useState([])
  let actionPlanUser = sessionStorage.getItem('actionPlanUser')
  const clientCode = JSON.parse(actionPlanUser)?.data?.uid?.split('-')[0].toUpperCase()
  const refreshPlans = useRecoilRefresher_UNSTABLE(InvestedPlansSelector)
  const subOneTime = useRecoilValueLoadable(MFUserSubSeqBaskets(clientCode))
  const refrshSubOneTime = useRecoilRefresher_UNSTABLE(MFUserSubSeqBaskets(clientCode))
  const { onOpen } = useModal()
  const [planToDelete, setPlanToDelete] = useState({})
  const navigate = useNavigate()
  const location = useLocation()
  const [open, setOpen] = useState(false)

  const receivedData =
    location.state?.data || (actionPlanUser ? JSON.parse(actionPlanUser)?.data : null)

  const [mfData, setMFData] = useState([])

  const fetchAllPlans = async () => {
    const url = `${env.API_URL}adminservice/api/actionPlan/getPlans`
    let customerId = receivedData?.id
    try {
      const response = await get(url, {}, { customerId })
      if (response?.response?.code === 400) {
        setPlans([])
        return
      }
      setPlans(response?.data || [])
    } catch (error) {
      console.log(error)
      setPlans([])
    }
  }

  const userMFBasket = async () => {
    const url = `${env.API_URL}adminservice/api/actionPlan/getUserMFBaskets`
    let clientCode = receivedData?.uid?.split('-')[0]?.toUpperCase()
    try {
      const response = await get(url, {}, { clientCode })
      setMFData(response?.data?.data || [])
    } catch (error) {
      console.log(error)
      setMFData([])
    }
  }

  useEffect(() => {
    fetchAllPlans()
    userMFBasket()
  }, [])

  useEffect(() => {
    const mergePlansWithOneTimeOrders = (plans, oneTimeOrders) => {
      if (!Array.isArray(oneTimeOrders)) {
        if (oneTimeOrders !== null && oneTimeOrders !== undefined) {
          console.error(
            'Expected oneTimeOrders to be an array, got:',
            typeof oneTimeOrders,
            oneTimeOrders,
          )
        }
        return []
      }

      return oneTimeOrders
        ?.map((order) => {
          const matchedPlan = mfData?.find(
            (basket) => basket.customerBasketInvestmentId === order.customerBasketInvestmentId,
          )

          if (matchedPlan) {
            return {
              oneTimeOrder: order,
              ...matchedPlan,
            }
          }
          return null
        })
        .filter(Boolean)
    }

    try {
      const subSeqPlans =
        subOneTime?.state === 'hasValue' && subOneTime?.contents?.data
          ? JSON.parse(subOneTime.contents.data)
          : null
      const result = mergePlansWithOneTimeOrders(plans, subSeqPlans?.data || [])

      setMergedPlans(result)
    } catch (error) {
      console.error('Error merging plans with one-time orders:', error?.message || error)
      setMergedPlans([])
    }
  }, [subOneTime.state, plans, mfData])

  useEffect(() => {
    if (!plans || plans.length === 0 || !mfData || mfData.length === 0) return

    const basketMap = mfData?.reduce((acc, basket) => {
      acc[basket.customerBasketInvestmentId] = basket.basketStatus
      return acc
    }, {})

    const userPlans = plans?.map((plan) => {
      if (basketMap[plan?.customerMfBasketInvestmentId]) {
        return { ...plan, status: basketMap[plan?.customerMfBasketInvestmentId] }
      }
      return plan
    })

    const isSame = JSON.stringify(plans) === JSON.stringify(userPlans)

    if (!isSame) {
      setPlans(userPlans)
    }

    if (
      plans &&
      plans?.length > 0 &&
      mfData?.state === 'hasValue' &&
      mfData?.contents?.length == 0
    ) {
      console.log(plans)
      setPlans(plans)
    }
  }, [])

  const handleDeleteDialogClose = () => {
    setOpenDeleteDialog(false)
  }
  const setMessageModalState = useSetRecoilState(messageModalState)

  const viewEditPlan = (item, basket) => {
    if (item.planType === 'CHILDEDUCATION') {
      navigate(
        '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/educationplan',
        { state: { SubOneTime: false, receivedData, basket: basket, plans: item, edit: true } },
      )
    } else if (item.planType === 'RETIREMENT') {
      navigate(
        '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/retirementplan',
        {
          state: { SubOneTime: false, receivedData, basket: basket, plans: item, edit: true },
        },
      )
    } else if (item.planType === 'MARRIAGE') {
      navigate(
        '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/weddingplan',
        {
          state: { SubOneTime: false, receivedData, basket: basket, plans: item, edit: true },
        },
      )
    } else if (item.planType === 'PURCHASE') {
      navigate(
        '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/purchaseplan',
        {
          state: {
            SubOneTime: false,
            receivedData,
            basket: basket,
            plans: item,
            edit: true,
          },
        },
      )
    } else if (item.planType === 'HOLIDAY') {
      navigate(
        '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/vacationplan',
        { state: { SubOneTime: false, receivedData, basket: basket, plans: item, edit: true } },
      )
    } else if (item.planType === 'EMERGENCY') {
      navigate(
        '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/emergencyplan',
        { state: { SubOneTime: false, receivedData, basket: basket, plans: item, edit: true } },
      )
    } else if (item.planType === 'HOME') {
      navigate(
        '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/homepurchaseplan',
        { state: { SubOneTime: false, receivedData, basket: basket, plans: item, edit: true } },
      )
    } else if (item.planType === 'VEHICLE') {
      navigate(
        '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/vehicleplan',
        { state: { SubOneTime: false, receivedData, basket: basket, plans: item, edit: true } },
      )
    } else if (item.planType === 'GENERALSAVING') {
      navigate(
        '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/generalsavingplan',
        { state: { SubOneTime: false, receivedData, basket: basket, plans: item, edit: true } },
      )
    } else if (item.planType === 'PASSION') {
      navigate(
        '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/passionplan',
        { state: { SubOneTime: false, receivedData, basket: basket, plans: item, edit: true } },
      )
    } else if (item.planType === 'JEWELLERY') {
      navigate(
        '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/jewelleryplan',
        { state: { SubOneTime: false, receivedData, basket: basket, plans: item, edit: true } },
      )
    }
  }

  const deletePlan = async (plan) => {
    try {
      const response = await deleteReq(`/planservice/api/plan/${plan.id}`)
      const url = `${env.API_URL}adminservice/api/actionPlan/deleteUserMFBasket/${plan.customerMfBasketInvestmentId}`
      let deleteResponse = await deleteReq(url)

      if (response.status === 204) {
        fetchAllPlans()
        refreshPlans()
        setMessageModalState({
          message: 'Plan deleted successfully',
          linkMessage: '',
          severity: 'info',
        })
      }
    } catch (e) {
      console.log(e)
    }
  }

  const deleteSubsequentOneTime = async (plan) => {
    try {
      const url = `${env.API_URL}adminservice/api/actionPlan/removeSubsequentOneTimeOrder/${plan.id}`
      const response = await deleteReq(url)

      if (response.status === 200) {
        await fetchAllPlans()
        refrshSubOneTime()
        setMessageModalState({
          message: 'Subsequent One Time deleted successfully',
          linkMessage: '',
          severity: 'info',
        })
      }
    } catch (e) {
      console.log(e)
    }
  }

  const AddSIP = (basketOrders) => {
    navigate(
      '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/basket/add-sip',
      {
        state: {
          basket: basketOrders,
          clientCode: clientCode,
        },
      },
    )
  }

  const subsequentEmptyMessage = (() => {
    if (subOneTime?.state !== 'hasValue') return null
    try {
      return JSON.parse(subOneTime?.contents?.data)?.message
    } catch {
      return null
    }
  })()

  return (
    <>
      <div className='mx-auto w-full max-w-none px-1 pb-8 pt-2 md:px-2'>
        <div className='mb-5 flex flex-col gap-3 md:mb-6 md:flex-row md:items-end md:justify-between'>
          <div>
            <p className='mb-1 text-xs font-medium uppercase tracking-[0.08em] text-[var(--fb-text-muted)]'>
              Admin tools
            </p>
            <h1 className='font-DMSans text-2xl font-bold tracking-tight text-[var(--fb-text-strong)] md:text-3xl'>
              Plans
            </h1>
            <p className='mt-1 text-sm text-[var(--fb-text-muted)]'>
              Create a new plan or review this user&apos;s existing baskets.
            </p>
          </div>

          <Button
            type='button'
            variant='outline'
            disabled={!receivedData?.uid}
            onClick={() => setOpen(true)}
            className='h-10 w-fit shrink-0 rounded-xl border-[var(--fb-border)] bg-[var(--fb-surface)] px-4 text-sm font-semibold text-[var(--fb-text)] hover:bg-[var(--fb-surface-muted)] disabled:opacity-50'
          >
            <Bell className='mr-2 size-4 text-[var(--fb-accent-text)]' />
            Send notification
          </Button>
        </div>

        <Card className='overflow-hidden border border-[var(--fb-border)] bg-[var(--fb-surface)] shadow-[var(--fb-shadow-sm)] lg:rounded-3xl'>
          <CardContent className='p-4 md:p-6'>
            <div className='mb-4'>
              <p className='text-xs font-medium uppercase tracking-[0.08em] text-[var(--fb-text-muted)]'>
                Create a plan
              </p>
              <p className='mt-1 text-sm text-[var(--fb-text-secondary)]'>
                Choose a goal type to start a new savings plan.
              </p>
            </div>
            <ActionCarousel receivedData={receivedData} plans={plans} mfData={mfData} />
          </CardContent>
        </Card>

        <section className='mt-8'>
          <div className='mb-4'>
            <h2 className='font-DMSans text-xl font-bold tracking-tight text-[var(--fb-text-strong)] md:text-2xl'>
              User Subsequent Plans
              {mergedPlans?.length > 0 ? ` (${mergedPlans.length})` : ''}
            </h2>
            <p className='mt-1 text-sm text-[var(--fb-text-muted)]'>
              Additional one-time and SIP orders placed after the original plan.
            </p>
          </div>

          <div className='grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-5 lg:grid-cols-3'>
            {subOneTime?.state === 'loading' && <PlanCardSkeletons />}

            {subOneTime?.state !== 'loading' && mergedPlans?.length === 0 && (
              <EmptyPlansState
                title='No subsequent plans'
                description={
                  subsequentEmptyMessage ||
                  'No additional one-time or SIP orders for this user.'
                }
              />
            )}

            {mergedPlans?.length > 0 &&
              mergedPlans.map((item, index) => (
                <PlanCardShell key={`subsequent-plan-${item?.customerBasketInvestmentId || index}`}>
                  <div className='flex items-start justify-between gap-3'>
                    <div className='flex min-w-0 items-center gap-3'>
                      <img
                        className='fabits-basket-row-icon size-11 shrink-0 rounded-xl md:size-12'
                        src={basketRowIcon}
                        alt=''
                        aria-hidden='true'
                      />
                      <h3 className='font-DMSans text-base font-bold leading-snug tracking-tight text-[var(--fb-text-strong)] md:text-lg'>
                        {item.customerBasketName}
                      </h3>
                    </div>

                    <Menubar className='h-auto border-0 bg-transparent p-0 shadow-none'>
                      <MenubarMenu>
                        <MenubarTrigger className='inline-flex size-8 items-center justify-center rounded-full p-0 hover:bg-[var(--fb-surface-muted)]'>
                          <EllipsisVertical className='size-4 text-[var(--fb-text-muted)]' />
                        </MenubarTrigger>
                        <MenubarContent className='rounded-xl border-[var(--fb-border)] bg-[var(--fb-surface)]'>
                          <MenubarItem
                            onClick={() => {
                              deleteSubsequentOneTime(item?.oneTimeOrder)
                            }}
                            className='cursor-pointer py-2 pl-3 text-sm text-[var(--fb-danger)] hover:bg-[var(--fb-danger-bg)]'
                          >
                            Delete
                          </MenubarItem>
                        </MenubarContent>
                      </MenubarMenu>
                    </Menubar>
                  </div>

                  <Separator className='my-4 bg-[var(--fb-border)]' />

                  <div className='grid grid-cols-1 gap-3 min-[380px]:grid-cols-2'>
                    {item?.oneTimeOrder?.orderInvestmentAmount ? (
                      <div className='rounded-xl border border-[var(--fb-border)] bg-[var(--fb-surface-muted)] p-3'>
                        <PlanMetric
                          label='One-time'
                          value={`₹${toCurrency(item.oneTimeOrder.orderInvestmentAmount)}`}
                        />
                        <button
                          type='button'
                          className='mt-3 text-xs font-semibold text-[var(--fb-accent-text)] hover:underline'
                          onClick={() => {
                            onOpen('OpenAdminMFBreakdown', {
                              constituents: item?.oneTimeOrder?.orderInvestmentBreakdown?.filter(
                                (fund) => (fund?.weightage || fund?.allocationAmount) > 0,
                              ),
                              amount: item?.oneTimeOrder?.orderInvestmentAmount,
                            })
                          }}
                        >
                          View breakdown
                        </button>
                      </div>
                    ) : null}

                    {item?.oneTimeOrder?.sipOrderInvestmentAmount ? (
                      <div className='rounded-xl border border-[var(--fb-border)] bg-[var(--fb-surface-muted)] p-3'>
                        <PlanMetric
                          label='SIP'
                          value={`₹${toCurrency(item.oneTimeOrder.sipOrderInvestmentAmount)}`}
                        />
                        <button
                          type='button'
                          className='mt-3 text-xs font-semibold text-[var(--fb-accent-text)] hover:underline'
                          onClick={() => {
                            onOpen('OpenAdminMFBreakdown', {
                              constituents: item?.oneTimeOrder?.sipOrderInvestmentBreakdown?.filter(
                                (fund) => fund.weightage > 0,
                              ),
                              amount: item?.oneTimeOrder?.sipOrderInvestmentAmount,
                            })
                          }}
                        >
                          View breakdown
                        </button>
                      </div>
                    ) : null}
                  </div>
                </PlanCardShell>
              ))}
          </div>
        </section>

        <section className='mt-8'>
          <div className='mb-4'>
            <h2 className='font-DMSans text-xl font-bold tracking-tight text-[var(--fb-text-strong)] md:text-2xl'>
              User All Plans
              {plans?.length > 0 ? ` (${plans.length})` : ''}
            </h2>
            <p className='mt-1 text-sm text-[var(--fb-text-muted)]'>
              Every savings plan created for this user.
            </p>
          </div>

          <div className='grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-5 lg:grid-cols-3'>
            {plans === undefined && <PlanCardSkeletons />}

            {plans?.length === 0 && (
              <EmptyPlansState
                title='No plans yet'
                description='Use the options above to create a new savings plan for this user.'
              />
            )}

            {plans?.length > 0 &&
              plans.map((item, index) => {
                const basket = mfData?.find(
                  (b) => b.customerBasketInvestmentId === item.customerMfBasketInvestmentId,
                )
                const status = getStatus(basket?.basketStatus ? basket?.basketStatus : item?.status)

                return (
                  <PlanCardShell key={`all-plan-${item?.id || index}`}>
                    <div className='flex items-start justify-between gap-3'>
                      <div className='flex min-w-0 items-start gap-3'>
                        <img
                          className='fabits-basket-row-icon size-11 shrink-0 rounded-xl md:size-12'
                          src={basketRowIcon}
                          alt=''
                          aria-hidden='true'
                        />
                        <div className='min-w-0'>
                          <h3 className='font-DMSans text-base font-bold leading-snug tracking-tight text-[var(--fb-text-strong)] md:text-lg'>
                            {basket?.customerBasketName ?? item.planName}
                          </h3>
                          <div className='mt-2 flex flex-wrap gap-1.5'>
                            {item.createdSource === 'ACTION PLAN' && (
                              <span className='rounded-full bg-[var(--fb-lime-200)] px-2.5 py-0.5 text-[11px] font-semibold text-[var(--fb-black)]'>
                                Admin Created
                              </span>
                            )}
                            {basket?.hasOwnProperty('customerBasketInvestmentId') && (
                              <span className='rounded-full border border-[var(--fb-warning-border)] bg-[var(--fb-warning-bg)] px-2.5 py-0.5 text-[11px] font-semibold text-[var(--fb-warning)]'>
                                Basket
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      {getStatus(basket?.basketStatus) === 'DRAFT' && (
                        <Menubar className='h-auto border-0 bg-transparent p-0 shadow-none'>
                          <MenubarMenu>
                            <MenubarTrigger className='inline-flex size-8 items-center justify-center rounded-full p-0 hover:bg-[var(--fb-surface-muted)]'>
                              <EllipsisVertical className='size-4 text-[var(--fb-text-muted)]' />
                            </MenubarTrigger>
                            <MenubarContent className='rounded-xl border-[var(--fb-border)] bg-[var(--fb-surface)]'>
                              <MenubarItem
                                onClick={() => viewEditPlan({
                                  ...item,
                                  customerMfBasketInvestmentId: basket.customerBasketInvestmentId,
                                  planName: basket.customerBasketName ?? item.planName,
                                  monthlySIP: basket.sipInvestmentAmount ?? item.monthlySIP,
                                  lumpsum: basket.oneTimeInvestmentAmount ?? item.lumpsum,
                                }, basket)}
                                className='cursor-pointer py-2 pl-3 text-sm'
                              >
                                Edit
                              </MenubarItem>
                              <MenubarItem
                                onClick={() => {
                                  setPlanToDelete(item)
                                  setOpenDeleteDialog(true)
                                }}
                                className='cursor-pointer py-2 pl-3 text-sm text-[var(--fb-danger)] hover:bg-[var(--fb-danger-bg)]'
                              >
                                Delete
                              </MenubarItem>
                            </MenubarContent>
                          </MenubarMenu>
                        </Menubar>
                      )}
                    </div>

                    <Separator className='my-4 bg-[var(--fb-border)]' />

                    <div className='grid grid-cols-2 gap-x-4 gap-y-4'>
                      <PlanMetric
                        label='Monthly SIP'
                        value={`₹${toCurrency(basket?.sipInvestmentAmount ?? item.monthlySIP)}`}
                      />
                      <PlanMetric
                        label='Goal Amount'
                        value={`₹${toCurrency(getGoalAmount(item))}`}
                      />
                      <PlanMetric label='Goal Year' value={item.results?.targetYear || '—'} />
                      <PlanMetric
                        label='Status'
                        value={capitalizeWords(status) || '—'}
                        valueClassName={getStatusClassName(status)}
                      />
                    </div>

                    <Separator className='my-4 bg-[var(--fb-border)]' />

                    <PlanMetric
                      label='One Time Investment'
                      value={`₹ ${toCurrency(basket?.oneTimeInvestmentAmount ?? item?.lumpsum ?? 0)}`}
                    />
                  </PlanCardShell>
                )
              })}
          </div>
        </section>
      </div>

      <AlertDialog open={openDeleteDialog} onOpenChange={handleDeleteDialogClose}>
        <AlertDialogContent className='border-[var(--fb-border)] bg-[var(--fb-surface)] py-8'>
          <AlertDialogHeader>
            <AlertDialogTitle className='font-DMSans font-semibold text-[var(--fb-text-strong)]'>
              Are you absolutely sure?
            </AlertDialogTitle>
            <AlertDialogDescription className='text-[var(--fb-text-muted)]'>
              Do you want to delete this {planToDelete.planName}?
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel
              onClick={() => {
                handleDeleteDialogClose()
              }}
            >
              No
            </AlertDialogCancel>
            <AlertDialogAction
              onClick={() => {
                deletePlan(planToDelete)
                setPlanToDelete({})
                setOpenDeleteDialog(false)
              }}
            >
              Yes
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      {open && receivedData?.uid && (
        <ActionNotification open={open} setOpen={setOpen} data={receivedData} />
      )}
    </>
  )
}

export default AddPlan
